/**
 *  Created by piotr@revisual.io on 08/08/2025
 */
import classNames from "classnames";
import useAnimateIn from "./useAnimateIn";
import PlanPrice from "./PlanPrice";

/**
 *
 * @param {Object} plan
 * @param {Object} price
 * @param {Object} discount
 * @param {boolean} showAction
 * @param {boolean} showImage
 * @param {function} onAction
 * @param {boolean} showBestDealLabel
 * @param {number} index
 * @param {string} actionLabel
 * @param {string} currency
 * @param {boolean} disabled
 *
 * @returns {JSX.Element}
 * @constructor
 */
export const SubscriptionPlanColumn = ({
  plan,
  price,
  showAction = true,
  showImage = true,
  onAction,
  showBestDealLabel = false,
  index,
  actionLabel = "Subscribe",
  discount,
  disabled = false,
}) => {
  const animationRef = useAnimateIn(index * 0.05);

  const actionButton = showAction ? (
    <div className={"subscription-plan-column-action"}>
      <button
        className={classNames("btn btn-primary w-100", {
          "btn-secondary": disabled,
        })}
        onClick={onAction(price, plan)}
        disabled={disabled}
      >
        {actionLabel}
      </button>
    </div>
  ) : null;

  const image =
    plan.images[0] && showImage ? (
      <div className={"subscription-plan-column-image"}>
        <img src={plan.images[0]} alt={plan.name} />
      </div>
    ) : null;

  const sandboxLabel = !price.livemode ? (
    <div className={"subscription-plan-column-sandbox"}>Sandbox</div>
  ) : null;

  const bestDealLabel = showBestDealLabel ? (
    <div className={"subscription-plan-column-best-deal"}>Best Deal</div>
  ) : null;

  return (
    <div
      ref={animationRef}
      className={classNames("card-box subscription-plan-column", {
        "subscription-plan-column_highlight": showBestDealLabel,
      })}
    >
      <div className={"card-box-subscription-plan-column-labels"}>
        {bestDealLabel}
        {sandboxLabel}
      </div>
      <div className={"subscription-plan-column-heading"}>
        {image}
        <div className={"subscription-plan-column-name"}>
          <h3>{plan.name}</h3>
          <p>{plan.description}</p>
        </div>
      </div>
      <div className={"subscription-plan-column-price-cta"}>
        <div className={"subscription-plan-column-price"}>
          <PlanPrice price={price} discount={discount} />
        </div>
        {actionButton}
      </div>
      <div className={"subscription-plan-column-features"}>
        <p>This includes:</p>
        <ul>
          {plan.marketing_features.map((feature, index) => (
            <li key={index}>
              <i className={"material-icons"}>check_circle</i> {feature.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SubscriptionPlanColumn;
